export const holdingUnitBusinessActivityKindValues = [
  'unitCreated',
  'materialAssigned',
  'materialCorrected',
  'identifierAssigned',
  'yardMoved',
  'weightAdded',
  'weightCorrected',
  'markedReady',
  'reopened',
  'transferIn',
  'transferOut',
  'baleCreated',
  'baleConsumed',
  'reservedForLoading',
  'returnedFromLoading',
  'shipmentDeparted',
  'shipmentReversed',
  'adjustmentApplied',
  'containerIdentityCorrected',
  'removedFromInventory',
  'reusableCycleReleased',
  'lifecycleChanged',
] as const;

export type HoldingUnitBusinessActivityKind =
  (typeof holdingUnitBusinessActivityKindValues)[number];

export interface HoldingUnitBusinessActivityWeight {
  beforeNetLb?: number;
  addedNetLb?: number;
  afterNetLb?: number;
  grossLb?: number | null;
  tareLb?: number | null;
  deltaNetLb?: number;
}

export interface HoldingUnitBusinessActivityChange {
  label: string;
  fromDisplay: string | null;
  toDisplay: string | null;
  note: string | null;
}

export interface HoldingUnitBusinessActivityReference {
  label: string;
  value: string;
}

export interface HoldingUnitBusinessActivityEntry {
  kind: HoldingUnitBusinessActivityKind;
  occurredAt: string;
  actorLabel: string;
  title: string;
  summary: string | null;
  reason: string | null;
  weight: HoldingUnitBusinessActivityWeight | null;
  changes: HoldingUnitBusinessActivityChange[];
  references: HoldingUnitBusinessActivityReference[];
}

export interface GetHoldingUnitBusinessActivityRequest {
  companyId: string;
  unitId: string;
}

export interface GetHoldingUnitBusinessActivityResponse {
  items: HoldingUnitBusinessActivityEntry[];
}
